import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { selectDisscountOfferId } from '../../../containers/App/actions';
import ModalSelector from '../../Modals/ModalSelector';
import {
  ModalOfferSearchFormWithoutStatus,
  ModalOfferSearchForm,
  ModalDisscountOfferSearchForm,
} from '../../PricingHub';

class ModalDisscountOffer extends Component {
  state = {};

  componentDidMount() {}

  render() {
    const tableConfig = {
      columns: [
        {
          name: 'id',
          label: 'common:label.id',
          render: (colName, item) => <span className="">{item.id}</span>,
        },
        {
          name: 'name',
          label: 'common:label.name',
          sortName: 'name',
        },
        {
          name: 'description',
          label: 'common:label.description',
        },
        {
          name: 'status',
          label: 'common:label.status',
        },
      ],
    };
    const { t, defaultSearchParams, isFullSearchForm } = this.props;
    let searchFormItem =
      defaultSearchParams && defaultSearchParams.status ? ModalOfferSearchFormWithoutStatus : ModalOfferSearchForm;
    if (isFullSearchForm) searchFormItem = ModalDisscountOfferSearchForm;

    return (
      <ModalSelector
        modalTitle={t('label.chooseDisscountOffer')}
        isOpen={this.props.isOpen}
        SearchForm={searchFormItem}
        searchItems={this.props.selectDisscountOfferId}
        tableColumns={tableConfig.columns}
        onSelect={this.props.onSelect}
        onCancel={this.props.onCancel}
        toggleModal={this.props.onCancel}
        selectedItemId={this.props.selectedBundleId}
        defaultSearchParams={this.props.defaultSearchParams}
      />
    );
  }
}

ModalDisscountOffer.propTypes = {
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  onCancel: PropTypes.func,
  selectedBundleId: PropTypes.any,
  selectDisscountOfferId: PropTypes.func,
  errorMessage: PropTypes.string,
  defaultSearchParams: PropTypes.object,
};

export default withTranslation('common')(connect(null, { selectDisscountOfferId })(ModalDisscountOffer));
